// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.linkToSource--hsalF {
  text-decoration: underline;
  color: black;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/EmbedHeader/styles.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,YAAY;AACd","sourcesContent":[".linkToSource {\n  text-decoration: underline;\n  color: black;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linkToSource": `linkToSource--hsalF`
};
export default ___CSS_LOADER_EXPORT___;
